<template>
  <div>
    <v-card>
      <v-title>Admin Options</v-title>
      <v-spacer></v-spacer>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="item in tabs" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <UserPermission v-if="tab == 0" />
        </v-tab-item>
        <v-tab-item>
          <MenuPermission v-if="tab == 1" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import globalMixin from '@/mixins/globalMixin'
import UserPermission from './user-permission.vue'
import MenuPermission from './menu-permission.vue'
export default {
  mixins: [globalMixin],
  components: {
    UserPermission,
    MenuPermission
  },
  data() {
    return {
      tab: null,
      tabs: ['Users', 'Permission Levels']
    }
  }
}
</script>
